import { Driver } from 'driver.js';
import { flushSync } from 'react-dom';
import { createRoot } from 'react-dom/client';
import { DefaultTheme, ThemeProvider } from 'styled-components/macro';
import { TourConfig } from '../tour.types';
import { Button, HStack } from 'components/ui';

const container = document.createElement('div');
document.body.appendChild(container);

const root = createRoot(container);

const DotsIndicator = ({
  theme,
  current,
  total,
}: {
  theme: DefaultTheme;
  current: number;
  total: number;
}) => {
  return (
    <HStack spacing="xxs" align="center">
      {Array.from({ length: total }).map((_, index) => (
        <div
          key={index}
          style={{
            width: '6px',
            height: '6px',
            borderRadius: '50%',
            backgroundColor:
              index === current
                ? theme.colors.primary[600]
                : theme.colors.white,
          }}
        />
      ))}
    </HStack>
  );
};

export const renderFooter = (
  theme: DefaultTheme,
  driver: Driver,
  config: TourConfig
) => {
  const isFirst = driver.isFirstStep();
  const isLast = driver.isLastStep();
  const currentIndex = driver.getActiveIndex() ?? 0;
  const totalSteps = driver.getConfig().steps?.length ?? 0;

  flushSync(() => {
    root.render(
      <ThemeProvider theme={theme}>
        <HStack
          align="flex-end"
          justify="space-between"
          style={{ marginTop: theme.spacings.base }}
        >
          <DotsIndicator
            current={currentIndex}
            total={totalSteps}
            theme={theme}
          />

          <HStack spacing="xs">
            {!isFirst && (
              <Button
                mode="accent"
                variant="ghost"
                size="s"
                onClick={driver.movePrevious}
              >
                Назад
              </Button>
            )}
            <Button mode="accent" size="s" onClick={driver.moveNext}>
              {isLast ? (config.lastButtonText ?? 'Всё понятно') : 'Дальше'}
            </Button>
          </HStack>
        </HStack>
      </ThemeProvider>
    );
  });

  return container;
};
